const handleFloating = (el, val) => {
  if (val) {
    el.parentNode.classList.add('filled')
  } else {
    el.parentNode.classList.remove('filled')
  }
}

export default {
  inserted(el) {
    handleFloating(el, el.value)
    el.onchange = (e) => {
      handleFloating(el, e.target.value)
    }
  },
  update(el) {
    handleFloating(el, el.value)
  },
}
